@import '../styles/fonts.scss';
@import '../styles/palette.scss';
@import './standards.module.scss';

.menu {
  @include barlowMedium(14);
  display: flex;
  flex-direction: column;
  max-width: 13rem;
  min-height: 100%;
  width: 13rem;

  &.permanent {
    background-color: _palette(bg-secondary);
    box-shadow: -2px 1px 10px 0 rgba(0, 0, 0, 0.75);
    position: fixed;
  }

  .menuFooter {
    border-top: $border-width solid _palette(bg-primary);
    bottom: 0;
    color: darkgrey;
    flex-shrink: 0;
    padding: 1rem 1.25rem 2rem 1.25rem;
    text-align: center;
    width: 100%;

    p {
      @include merriweather(18);
      color: _palette(secondary);
    }
  }

  .icon {
    align-items: center;
    display: flex;
    height: 100%;
    margin-left: 0.5rem;
  }

  .contentWrapper {
    flex: 1 0 auto;

    & > * {
      text-decoration: none;
    }
  }

  .menuTopItem,
  .menuItem {
    align-items: center;
    color: inherit;
    display: flex;
    text-decoration: none !important;
    width: 100%;

    .icon {
      .primaryIcon {
        background-color: _palette(text-white);
        border-radius: 50%;
        height: 2.75rem;
        padding: 0.5rem;
        width: 2.75rem;
      }
    }
  }

  .menuItem {
    border-right: 0.375rem solid transparent;
    cursor: pointer;
    padding-left: 0.75rem;

    &.active {
      border-right: 0.375rem solid _palette(secondary);

      & .innerItemBox {
        .icon {
          .secondaryIcon {
            & * {
              fill: _palette(secondary);
              opacity: 100;
            }
          }
        }
      }
    }

    &:not(.active) {
      & .innerItemBox {
        .icon {
          .secondaryIcon {
            & * {
              fill: _palette(text-disabled);
              opacity: 100;
            }
          }
        }
      }
    }

    & .innerItemBox {
      align-items: center;
      border-radius: 5px;
      display: flex;
      padding: 0.5rem 1rem 0.5rem 0.5rem;
      width: 100%;

      .icon {
        .secondaryIcon {
          margin-right: 0.5rem;
        }
      }
    }

    &:hover {
      & .innerItemBox {
        background-color: _palette(bg-primary);
      }

      .name {
        text-decoration: underline;
      }
    }
  }

  .menuTopItem {
    @include barlow(12);
    align-items: flex-start;
    color: white;
    display: flex;
    height: 4.125rem; // Height of mui-navbar + padding for border
    justify-content: left;
    min-height: 66px;
    padding-left: 0.75rem;

    &:not(.praksissted):not(.studiested):not(.student):not(.sysadmin) {
      background-color: _palette(bg-secondary);
      color: _palette(text);
    }

    &.praksissted {
      background-color: _palette(primary-dark);

      .icon {
        .primaryIcon {
          color: _palette(primary-dark);
        }
      }
    }

    &.studiested {
      background-color: _palette(secondary-dark);

      .icon {
        .primaryIcon {
          color: _palette(secondary-dark);
        }
      }
    }

    &.student {
      background-color: _palette(student-menu-color);

      .icon {
        .primaryIcon {
          color: _palette(student-menu-color);
        }
      }
    }

    &.sysadmin {
      background-color: black;

      .icon {
        .primaryIcon {
          color: _palette(text);
        }
      }
    }

    .icon {
      @include barlow(16, 600);
      margin: auto auto auto 0.5rem;
    }

    .name {
      margin: auto;
      padding: 0 1.5rem 0 1rem;
    }
  }

  .userItem {
    @include barlowMedium(14);
    border-bottom: $border-width solid _palette(bg-primary);
    height: auto;
    margin-bottom: 0.75rem;
    max-height: 6.25rem;
    min-height: 4.125rem;
    padding-left: 0.75rem;
    text-align: center;

    .icon {
      background-color: _palette(close-icon);
      border-radius: 50%;
      display: inline-block;
      margin: auto auto auto 0.5rem;
      max-height: 2.75rem;
      max-width: 2.75rem;
      min-height: 2.75rem;
      min-width: 2.75rem;

      .whiteText {
        @include barlow(18, 700);
        color: _palette(text-white);
        padding: 0 0.25rem 0 0.35rem;
        transform: translateY(35%);
      }
    }

    .name {
      margin-left: 0;
      padding-left: 0;
    }
  }
}

.profileLink:hover {
  .name {
    text-decoration: underline;
  }
}

.version {
  display: flex;
  justify-content: space-between;

  .env {
    @include barlowMedium(14);
    color: _palette(primary);
  }

  .version {
    @include barlowMedium(14);
    color: _palette(text-secondary);
  }
}
